export enum AnimationStage {
  TextOnly = 'text-only',
  WithVbar = 'with-vbar',
  VbarCard = 'vbar-card',
  Reset = 'reset',
}
